import React from 'react';
import ReactDOM from 'react-dom';
import { I18nextProvider } from 'react-i18next';
import { BrowserRouter } from 'react-router-dom';
import i18next from './i18n';
import { UserContextProvider } from './context/UserContext';
import { AppWrapper } from './wrapper';
import { LaunchDarklyProvider } from './v2/context/LaunchDarklyProvider';

import './utils/showVersion';

ReactDOM.render(
  <React.StrictMode>
    <LaunchDarklyProvider>
      <UserContextProvider>
        <BrowserRouter>
          <I18nextProvider i18n={i18next}>
            <AppWrapper />
          </I18nextProvider>
        </BrowserRouter>
      </UserContextProvider>
    </LaunchDarklyProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);
